module.exports = __webpack_public_path__ + "static/media/01.a7b599e7.svg";